import { Col } from "@commonlibs";
import styled, { css } from "styled-components";
import { RadioButtonGroup } from "ui/common/components/input/RadioButtonGroup/RadioButtonGroup";

export const OperationTypeSelectorRoot = styled(Col)(
    () => css`
        width: 600px;
        max-height: 350px;
        overflow-y: scroll;
        padding-right: 30px;
    `,
);

export const RadioButtonGroupRoot = styled(RadioButtonGroup)(
    () => css`
        color: red;
        .FormControl {
            color: red !important;
        }
    `,
);
